import React from 'react';
import './styles.css';

function TableWrapper({ columns, data, renderRow }) {
    return (
        <table className="generic-table">
            <thead className="table-header">
                <tr>
                    {columns.map(column => (
                        <th key={column.key}>{column.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody className="table-body">
                {data.map(renderRow)}
            </tbody>
        </table>
    );
}

export default TableWrapper;